import logo from './logo.svg';

import Header from './header';

import './styles/mobile.css'
import './styles/styles.css'
import  "./styles/card.css"

import "./styles/Downloadbtn.css"
import "./styles/footer.css"
import "./styles/feedback-form.css"
import "./styles/downloads.css"
import "./styles/resultados.css"
import "./styles/Announcements.css"
import "./styles/Loaders.css"
import "./styles/MonthModContext.css"
import Catalogo from './Catalogo';

function App() {
  return (
    <>
    <Catalogo/>
    </>
  );
}

export default App;
